/* eslint-disable */
import { useState, useContext, useEffect } from 'react'
import styles from './index.module.scss'
import { FormButton } from '../../components/core/button'
import { GeneralInput } from '../../components/core/input'
import StepLine from '../../components/core/stepLine'
import { Help, SearchIcon, Plus, Close, Add, Remove } from '../../icons'
import text from './text.json'
import { PageContext } from '../../context/PageContextProvider'
import JournalAPI from '../../api/journal'
import Loading from '../../components/pages/loading'

const JournalForm2 = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [choices, setChoices] = useState([])
  const [input, setInput] = useState('')
  const [current, setCurrent] = useState(0)
  const [options, setOptions] = useState([])
  const [data, setData] = useState([])
  const [categories, setCategories] = useState([])
  const [results, setResults] = useState([])

  useEffect(() => {
    (async () => {

    const { data } = await JournalAPI.getCategories()
    await setData(data)
    let arr = []
    await data.forEach((item) => {
      arr = [...arr, ...item.subcategory]
    })
    await setCategories(arr)
    await setLoad(true)
  
    })();
  }, [])
  const addHandle = (item) => {
    if (options.includes(item)) {
      let x = [...options]
      const index = x.indexOf(item)
      if (index > -1) {
        x.splice(index, 1)
        setOptions(x)
      }
    } else {
      let x = [...options]
      x.push(item)
      setOptions(x)
    }
  }
  const optionHandle = () => {
    let choice = [...choices]
    let inp = input.trim()
    if (inp !== '' && !options.includes(inp) && !choices.includes(inp)) {
      choice.push(inp)
      setChoices(choice)
      setInput('')
    }
  }
  const removeHandle = (item) => {
    let choice = [...choices]
    let index = choice.indexOf(item)
    choice.splice(index, 1)
    setChoices(choice)
  }
  const removeHandle2 = (item) => {
    let option = [...options]
    let index = option.indexOf(item)
    option.splice(index, 1)
    setOptions(option)
  }
  const sendAppeal = async () => {
    let data = await JSON.parse(sessionStorage.getItem('journal'))
    let new_opt = options.map((item) => item[language])
    let arr = await [...choices, ...new_opt]
    data.options = await arr
    let response = await JournalAPI.insert(data)
    if (response.status === 200) {
      sessionStorage.removeItem('journal')
      window.location.href = '/success'
    }
  }
  const getResults = (e) => {
    let value = e.target.value
    let arr = []
    if (value.length > 4) {
      categories.forEach((item) => {
        if (item[language].toLowerCase().includes(value.toLowerCase())) {
          arr.push(item)
        }
      })
    }
    setResults(arr)
  }
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <StepLine active={1} data={text.steps} />
      <div className={`${styles.content}`}>
        <h2>
          <Help />
          {text.question[language]}
        </h2>
        <div className={`${styles.search}`}>
          <label>
            <SearchIcon />
            <input
              onInput={(e) => getResults(e)}
              type="search"
              placeholder={text.placeholder[language]}
            />
          </label>
          {results.length > 0 && (
            <ul>
              <p>{text.result[language]}</p>
              {results.map((item, index) => (
                <li key={index}>
                  {item[language]}{' '}
                  <Add
                    onClick={() => {
                      addHandle(item)
                    }}
                  />
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className={styles.table}>
          <div>
            <p>{text.category[language]}</p>
            <ul>
              {data.map((item, i) => (
                <li
                  style={current === i ? { color: '#166FE5' } : null}
                  onClick={() => {
                    setCurrent(i)
                  }}
                  key={i}
                >
                  {item.category[language]}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p>{text.subcategory[language]}</p>
            <ul>
              {data[current].subcategory.map((item, i) => (
                <li
                  style={options.includes(item) ? { color: '#166FE5' } : null}
                  onClick={() => {
                    addHandle(item)
                  }}
                  key={i}
                >
                  {item[language]}
                </li>
              ))}
            </ul>
            <div className={styles.line} />
            <span>{text.label[language]}</span>
            <div className={styles.add}>
              <GeneralInput
                value={input}
                onInput={(e) => setInput(e.target.value)}
                placeholder={text.enter[language]}
              />
              <button
                onClick={() => {
                  optionHandle()
                }}
              >
                <Plus />
                {text.add[language]}
              </button>
            </div>
          </div>
          <div>
            <div>
              <p>{text.options[language]}</p>
              <ul>
                {options.map((item, i) => (
                  <li key={i}>
                    {item[language]}{' '}
                    <Remove
                      onClick={() => {
                        removeHandle2(item)
                      }}
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p>{text.special[language]}</p>
              <ul>
                <div>
                  {choices.map((item, i) => (
                    <li key={i}>
                      {item}
                      <Close
                        button
                        onClick={() => {
                          removeHandle(item)
                        }}
                      />
                    </li>
                  ))}
                </div>
              </ul>
            </div>
          </div>
        </div>

        <FormButton onClick={() => sendAppeal()}>
          {text.button[language]}
        </FormButton>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default JournalForm2
